"use client";

import { useEffect } from "react";
import { observeSession } from "../../../../packages/identity-session/src/observeSession";
import { synchronizePortalIdentity } from "../lib/portalSessionSync";

export function PortalIdentitySync({ appOrigin, initialRevision }: { appOrigin: string; initialRevision: string | null | undefined }) {
  useEffect(() => observeSession(async (signal) => {
    const revision = await synchronizePortalIdentity(appOrigin, signal);
    if (!signal.aborted && revision !== initialRevision) window.location.reload();
  }), [appOrigin, initialRevision]);
  return null;
}
